var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "mb-3"
  }, _vm._l((_vm.activeGroups), function(group, index) {
    return _c('div', {
      key: index,
      staticClass: "spnod-admin__account--block mb-1"
    }, [_vm._v("\n      " + _vm._s(group.name) + " "), _c('button', {
      staticClass: "text-danger",
      on: {
        "click": function($event) {
          return _vm.$emit('handleRemove', group)
        }
      }
    }, [_vm._v("X")])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('b-button', {
    staticClass: "spnod-admin__form--button mr-2",
    attrs: {
      "size": "sm"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('b-form-select', {
    staticClass: "form-control py-1 flex-grow-1",
    attrs: {
      "size": "sm"
    },
    model: {
      value: (_vm.newGroup),
      callback: function($$v) {
        _vm.newGroup = $$v
      },
      expression: "newGroup"
    }
  }, [_c('option', {
    key: 0,
    domProps: {
      "value": null
    }
  }, [_vm._v("Add to existing Group")]), _vm._v(" "), _vm._l((_vm.groups), function(group, index) {
    return _c('option', {
      key: index + 1,
      domProps: {
        "value": group
      }
    }, [_vm._v("\n        " + _vm._s(group.name) + "\n      ")])
  })], 2)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f02914c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/UserAccount/UserAccountGroupForm.vue
// module id = Jw8C
// module chunks = 2